module.exports = __webpack_public_path__ + "img/subtitle1.b7c6c4c6.png";